import { useSelector } from '@/store';

export const IMPLEMENTED_ROUTES = [
  '/hes',
  '/vee',
  '/access-panel',
  'energy-accounting'
];

const useGetPermissionRoutesObj = () => {
  const permissions = useSelector((state) => state.auth.permissions);
  const unimplementedPermissions = permissions
    .filter((permission) => !IMPLEMENTED_ROUTES.includes(permission))
    .map((item) => item.replaceAll('/', ''));
  const implementedRoutes = permissions.filter((permission) =>
    IMPLEMENTED_ROUTES.includes(permission)
  );

  return {
    permissions,
    unimplementedPermissions,
    implementedRoutes
  };
};

export default useGetPermissionRoutesObj;
